"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _core = require("@react-page/core");

var _reactToastify = require("react-toastify");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoConfig = require("@peracto/peracto-config");

var _client = require("@peracto/client");

var _peractoHooks = require("@peracto/peracto-hooks");

var _reactHelmet = require("react-helmet");

var _core2 = require("@chakra-ui/core");

var _react2 = require("@emotion/react");

var _config = _interopRequireWildcard(require("../../config"));

var _editor = _interopRequireDefault(require("../../service/editor"));

var _library = _interopRequireDefault(require("../../service/library"));

var _Editable = _interopRequireDefault(require("../Editable"));

var _Toolbar = _interopRequireDefault(require("../Toolbar"));

var _RightPanel = _interopRequireDefault(require("../RightPanel"));

var _LeftPanel = _interopRequireDefault(require("../LeftPanel"));

var _PageTitle = _interopRequireDefault(require("../PageTitle"));

var _peractoContent = require("@peracto/peracto-content");

require("@react-page/core/lib/index.css");

var S = _interopRequireWildcard(require("../../styled"));

var _styled2 = require("./styled");

var _excluded = ["body"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PeractoEditor = function PeractoEditor(_ref) {
  var _settings$backgroundI;

  var _ref$defaultPlugin = _ref.defaultPlugin,
      defaultPlugin = _ref$defaultPlugin === void 0 ? null : _ref$defaultPlugin,
      _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? {
    content: [],
    layout: []
  } : _ref$plugins,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _core2.theme : _ref$theme,
      _ref$pluginDecorator = _ref.pluginDecorator,
      pluginDecorator = _ref$pluginDecorator === void 0 ? _peractoContent.PluginDecorator : _ref$pluginDecorator;
  var conf = new _config["default"](plugins, config);

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client,
      loading = _useClient.loading;

  var _useParams = (0, _reactRouterDom.useParams)(),
      type = _useParams.type,
      id = _useParams.id;

  var peractoConfig = (0, _peractoConfig.useConfig)();

  var _peractoConfig$get = peractoConfig.get('editorConfig', null),
      globalStyles = _peractoConfig$get.globalStyles,
      bodyStyles = _peractoConfig$get.bodyStyles;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      redirect = _useState2[0],
      setRedirect = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      editor = _useState4[0],
      setEditor = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      notFound = _useState6[0],
      setNotFound = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      unauthorised = _useState8[0],
      setUnauthorised = _useState8[1];

  var _useState9 = (0, _react.useState)((0, _core.createEmptyState)()),
      _useState10 = _slicedToArray(_useState9, 2),
      content = _useState10[0],
      setContent = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      peractoSettings = _useState12[0],
      setPeractoSettings = _useState12[1];

  var _useState13 = (0, _react.useState)({
    name: '',
    title: '',
    metaDescription: '',
    image: '',
    locale: '',
    shortDescription: '',
    slug: '',
    keywords: [],
    contentProductLinks: [],
    contentBabbageAccountRestriction: [],
    contentAccessRestrictions: [],
    flattenedContentAccessRestrictions: [],
    searchable: true,
    backgroundImage: '',
    backgroundRepeat: '',
    backgroundSize: '',
    backgroundPosition: '',
    backgroundContain: false,
    countryCode: 'all'
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      settings = _useState14[0],
      setSettings = _useState14[1];

  var contentBodyStyle = {};

  if ((settings === null || settings === void 0 ? void 0 : (_settings$backgroundI = settings.backgroundImage) === null || _settings$backgroundI === void 0 ? void 0 : _settings$backgroundI.length) > 0) {
    contentBodyStyle = _objectSpread(_objectSpread({}, contentBodyStyle), {}, {
      backgroundImage: "url(\"".concat(settings === null || settings === void 0 ? void 0 : settings.backgroundImage, "\")"),
      backgroundRepeat: settings === null || settings === void 0 ? void 0 : settings.backgroundRepeat,
      backgroundSize: settings === null || settings === void 0 ? void 0 : settings.backgroundSize,
      backgroundPosition: settings === null || settings === void 0 ? void 0 : settings.backgroundPosition
    });
  }

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showSettings = _useState16[0],
      setShowSettings = _useState16[1];

  var createEditor = function createEditor(data) {
    var editor = new _editor["default"]({
      defaultPlugin: defaultPlugin,
      plugins: pluginDecorator.decoratePlugins(plugins),
      editables: [data]
    });
    editor.setLibraryService(new _library["default"]());
    setEditor(editor);
  };

  var onFetchData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _settings$contentAcce, _yield$client, data, body, _settings, contentData, flattenedContentAccessRestrictions, _settings$contentAcce2;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!id) {
                _context.next = 22;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return client(_client.GET_ONE, 'contents', {
                id: '/contents/' + id
              });

            case 4:
              _yield$client = _context.sent;
              data = _yield$client.data;
              body = data.body, _settings = _objectWithoutProperties(data, _excluded);
              contentData = JSON.parse(body)[0];
              flattenedContentAccessRestrictions = [];

              if ((_settings === null || _settings === void 0 ? void 0 : (_settings$contentAcce = _settings.contentAccessRestrictions) === null || _settings$contentAcce === void 0 ? void 0 : _settings$contentAcce.length) > 0) {
                flattenedContentAccessRestrictions = _settings === null || _settings === void 0 ? void 0 : (_settings$contentAcce2 = _settings.contentAccessRestrictions) === null || _settings$contentAcce2 === void 0 ? void 0 : _settings$contentAcce2.map(function (restriction) {
                  return restriction.value;
                });
              }

              createEditor(contentData);
              setContent(contentData);
              setSettings(_objectSpread(_objectSpread({}, _settings), {}, {
                flattenedContentAccessRestrictions: flattenedContentAccessRestrictions,
                title: _settings.title && _settings.title.length > 0 ? _settings.title : _settings.name
              }));
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

              if (_context.t0.status === 403) {
                setUnauthorised(true);
              }

              if (_context.t0.status === 404) {
                setNotFound(true);
              }

            case 20:
              _context.next = 23;
              break;

            case 22:
              return _context.abrupt("return", Promise.resolve());

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 15]]);
    }));

    return function onFetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (typeof client === 'function') {
      if (id) {
        onFetchData();
      } else {
        createEditor(content);
        setShowSettings(true); // show settings panel by default on new pages
      }
    }
  }, [client, id]);

  var fetchSettings = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$client2, data, settingsData;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return client(_client.GET_LIST, 'configurations', {
                id: 'configurations'
              });

            case 3:
              _yield$client2 = _context2.sent;
              data = _yield$client2.data;
              settingsData = {
                groups: {},
                values: {}
              };
              data.forEach(function (row) {
                settingsData.groups = _objectSpread(_objectSpread({}, settingsData.groups), row.groups);
                settingsData.values = _objectSpread(_objectSpread({}, settingsData.values), row.values);
              });
              setPeractoSettings(settingsData);
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function fetchSettings() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onSave = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _settings$contentProd, _settings$contentBabb, _settings$flattenedCo;

      var indexContent,
          content,
          method,
          _content$,
          _content$$cells,
          _content$$cells$,
          _content$$cells$$rows,
          _content$2,
          _content$2$cells,
          _content$2$cells$,
          headers,
          parsedSettings,
          _yield$client3,
          data,
          _e$error,
          _e$error$body,
          _e$error$body$violati,
          _e$error2,
          _e$error2$body,
          _args3 = arguments;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              indexContent = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              content = editor.query.editables().map(function (e) {
                return editor.plugins.serialize(e);
              });
              method = id ? _client.UPDATE : _client.CREATE;

              if (!(type === 'template')) {
                _context3.next = 10;
                break;
              }

              if (!((content === null || content === void 0 ? void 0 : (_content$ = content[0]) === null || _content$ === void 0 ? void 0 : (_content$$cells = _content$.cells) === null || _content$$cells === void 0 ? void 0 : (_content$$cells$ = _content$$cells[0]) === null || _content$$cells$ === void 0 ? void 0 : (_content$$cells$$rows = _content$$cells$.rows) === null || _content$$cells$$rows === void 0 ? void 0 : _content$$cells$$rows.length) > 1)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", _reactToastify.toast.warn('Templates can only support a single row. Ensure all blocks sit within a single Container before saving.'));

            case 8:
              content === null || content === void 0 ? true : (_content$2 = content[0]) === null || _content$2 === void 0 ? true : (_content$2$cells = _content$2.cells) === null || _content$2$cells === void 0 ? true : (_content$2$cells$ = _content$2$cells[0]) === null || _content$2$cells$ === void 0 ? true : delete _content$2$cells$.id;
              content[0].cells[0].layout = {
                plugin: {
                  name: 'peracto/layout/container',
                  version: '1.0.0'
                },
                state: {}
              };

            case 10:
              headers = {};

              if (indexContent) {
                headers['peracto-index-content'] = true;
              }

              parsedSettings = _objectSpread({}, settings);

              if (!['article', 'page'].includes(type)) {
                delete parsedSettings.searchable;
              }

              if (['element', 'template'].includes(type)) {
                delete parsedSettings.slug;
              }

              if ((settings === null || settings === void 0 ? void 0 : (_settings$contentProd = settings.contentProductLinks) === null || _settings$contentProd === void 0 ? void 0 : _settings$contentProd.length) > 0) {
                parsedSettings.contentProductLinks = settings === null || settings === void 0 ? void 0 : settings.contentProductLinks.map(function (product, idx) {
                  var _ref5;

                  var isNew = product['@id'].includes('/products/');
                  return _ref5 = {}, _defineProperty(_ref5, isNew ? 'product' : '@id', product['@id']), _defineProperty(_ref5, "productDisplayOrder", idx + 1), _ref5;
                });
              }

              if ((settings === null || settings === void 0 ? void 0 : (_settings$contentBabb = settings.contentBabbageAccountRestriction) === null || _settings$contentBabb === void 0 ? void 0 : _settings$contentBabb.length) > 0) {
                parsedSettings.contentBabbageAccountRestriction = settings === null || settings === void 0 ? void 0 : settings.contentBabbageAccountRestriction.map(function (restriction) {
                  return {
                    babbageAccount: restriction.babbageAccount
                  };
                });
              }

              if ((settings === null || settings === void 0 ? void 0 : (_settings$flattenedCo = settings.flattenedContentAccessRestrictions) === null || _settings$flattenedCo === void 0 ? void 0 : _settings$flattenedCo.length) > 0) {
                parsedSettings.contentAccessRestrictions = settings === null || settings === void 0 ? void 0 : settings.flattenedContentAccessRestrictions.map(function (restriction) {
                  var existingRestriction = settings === null || settings === void 0 ? void 0 : settings.contentAccessRestrictions.find(function (existingRestriction) {
                    return existingRestriction.value === restriction;
                  });

                  if (existingRestriction) {
                    return existingRestriction['@id'];
                  } else {
                    return {
                      type: 'NOT_USER_GROUP',
                      value: restriction,
                      content: id ? "/contents/".concat(id) : null
                    };
                  }
                });
              } else {
                parsedSettings.contentAccessRestrictions = [];
              }

              _context3.prev = 18;
              _context3.next = 21;
              return client(method, 'contents', {
                data: _objectSpread(_objectSpread({}, parsedSettings), {}, {
                  title: parsedSettings.title.length > 0 ? parsedSettings.title : parsedSettings.name,
                  type: parsedSettings.type || type,
                  locale: parsedSettings.locale || 'en_GB',
                  body: [JSON.stringify(content)]
                }),
                id: id ? "/contents/".concat(id) : null
              }, headers);

            case 21:
              _yield$client3 = _context3.sent;
              data = _yield$client3.data;

              if (data.violations && data.violations.length > 0) {
                if (data.violations[0].propertyPath === 'name') {
                  setShowSettings(true);

                  _reactToastify.toast.error(data.violations[0].message);
                } else {
                  _reactToastify.toast.error(data.violations.map(function (err) {
                    return err.message;
                  }).join('\n'));
                }
              } else {
                if (method === _client.CREATE) {
                  setRedirect("/content/edit/".concat(data.type, "/").concat(data.originId));
                } else {
                  window.location.href = "/content/edit/".concat(data.type, "/").concat(data.originId);
                }

                _reactToastify.toast.success('Content successfully saved!');

                setShowSettings(false);
              }

              _context3.next = 30;
              break;

            case 26:
              _context3.prev = 26;
              _context3.t0 = _context3["catch"](18);
              console.error(_context3.t0);

              if ((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_e$error = _context3.t0.error) === null || _e$error === void 0 ? void 0 : (_e$error$body = _e$error.body) === null || _e$error$body === void 0 ? void 0 : (_e$error$body$violati = _e$error$body.violations) === null || _e$error$body$violati === void 0 ? void 0 : _e$error$body$violati.length) > 0) {
                if ((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_e$error2 = _context3.t0.error) === null || _e$error2 === void 0 ? void 0 : (_e$error2$body = _e$error2.body) === null || _e$error2$body === void 0 ? void 0 : _e$error2$body.violations[0].propertyPath) === 'name') {
                  setShowSettings(true);

                  _reactToastify.toast.error(_context3.t0.error.body.violations[0].message);
                } else {
                  _reactToastify.toast.error(_context3.t0.error.body.violations.map(function (err) {
                    return err.message;
                  }).join('\n'));
                }
              }

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[18, 26]]);
    }));

    return function onSave() {
      return _ref4.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (!loading) {
      fetchSettings();
    }
  }, [loading]);

  if (!editor) {
    if (notFound) {
      return (0, _react2.jsx)(S.LayoutWrapper, null, (0, _react2.jsx)(_peractoUi.NotFoundMessage, {
        url: "/".concat(type, "s"),
        message: "The ".concat(type, " you're looking for could not be found"),
        buttonLabel: "Go to ".concat(type, "s")
      }));
    } else if (unauthorised) {
      return (0, _react2.jsx)(S.LayoutWrapper, null, (0, _react2.jsx)(_peractoUi.UnauthorisedMessage, null));
    } else {
      return (0, _react2.jsx)(S.LayoutWrapper, null, (0, _react2.jsx)(S.Header, null, (0, _react2.jsx)(_PageTitle["default"], {
        title: "Loading...",
        showSettings: showSettings,
        setShowSettings: setShowSettings,
        contentType: type
      })), (0, _react2.jsx)(S.BodyLoading, null, (0, _react2.jsx)(_peractoUi.LoadingIcon, null)));
    }
  }

  return (0, _react2.jsx)(_react["default"].Fragment, null, redirect && (0, _react2.jsx)(_reactRouterDom.Redirect, {
    to: redirect
  }), (0, _react2.jsx)(_reactHelmet.Helmet, null, id ? (0, _react2.jsx)("title", null, settings.name, " | Editing | Peracto") : (0, _react2.jsx)("title", null, "Add Content | Peracto")), (0, _react2.jsx)(_core2.ThemeProvider, {
    theme: theme
  }, (0, _react2.jsx)(_config.EditorConfigProvider, {
    config: conf
  }, (0, _react2.jsx)(_peractoHooks.SettingsProvider, {
    settings: peractoSettings
  }, (0, _react2.jsx)(_core.ReduxProvider, {
    store: editor.store
  }, (0, _react2.jsx)(S.LayoutWrapper, null, (0, _react2.jsx)(S.Header, null, (0, _react2.jsx)(_PageTitle["default"], {
    title: settings.name,
    showSettings: showSettings,
    setShowSettings: setShowSettings,
    contentType: type
  }), (0, _react2.jsx)(_Toolbar["default"], {
    onSave: onSave
  })), (0, _react2.jsx)(S.Wrapper, null, (0, _react2.jsx)(_LeftPanel["default"], {
    settings: settings,
    setSettings: setSettings,
    showSettings: showSettings,
    contentType: type
  }), (0, _react2.jsx)(_styled2.Body, {
    id: "editor-content-body",
    className: "!font-body",
    style: bodyStyles || {}
  }, globalStyles ? (0, _react2.jsx)("div", {
    css: globalStyles,
    "data-testid": "editor-body"
  }, (0, _react2.jsx)("div", {
    style: contentBodyStyle
  }, (0, _react2.jsx)(_Editable["default"], {
    editor: editor,
    id: content.id
  }))) : (0, _react2.jsx)(_Editable["default"], {
    editor: editor,
    id: content.id
  })), (0, _react2.jsx)(_RightPanel["default"], {
    editor: editor,
    plugins: plugins
  }))))))));
};

var _default = PeractoEditor;
exports["default"] = _default;